import MobileDetect from 'mobile-detect';

const checkWindow = () => typeof window !== 'undefined';
const isFullscreen = () => (checkWindow() ? window.innerHeight === window.screen.height : false);

const md = checkWindow() ? new MobileDetect(window.navigator.userAgent) : null;

const shouldHideFullscreenButton = () => {
  if (!checkWindow()) return false;
  // iOS does not have a concept of fullscreen and sometimes in a mobile app,
  if ('standalone' in window.navigator) return true;
  // embeds can be included as the webView URL rather than being in a frame,
  // in this case we cannot go fullscreen (it is fullscreen according to android) so hide fullscreen button
  if (window.location.pathname.includes('/embed/') && window === window.parent && md.mobile()) {
    return true;
  }
  return false;
};

const defaultLayout = {
  width: 0,
  height: 0,
  isFullscreen: isFullscreen(),
  modalType: false,
  showControls: false,
  isMobile: checkWindow() ? md.mobile() : false,
  isEmbed: false,
  // standalone is an iOS specific and iOS devices don't have fullscreen option
  hideFullscreenButton: shouldHideFullscreenButton(),
  miniUi: false,
  hideUi: false,
};

export default function layout(state = defaultLayout, action) {
  switch (action.type) {
    case 'SET_VIEWER_OPTIONS': {
      return { ...state, isEmbed: action.options.isEmbed };
    }
    case 'UPDATE_WINDOW_SIZE': {
      const element = action.rootElement;

      // Clamp the dimensions to 1. Lots of logic depends on these being non-zero, and we need to support rootElement
      // being temporarily hidden. [WML 15/03/19]
      const width = Number.isNaN(element.clientWidth) || element.clientWidth <= 0 ? 1 : element.clientWidth;
      const height = Number.isNaN(element.clientHeight) || element.clientHeight <= 0 ? 1 : element.clientHeight;

      return {
        ...state,
        isFullscreen: isFullscreen(),
        width,
        height,
      };
    }
    case 'TOGGLE_CONTROLS':
      return { ...state, showControls: !action.showControls };
    case 'TOGGLE_MINI_UI':
      return { ...state, miniUi: !state.miniUi };
    case 'TOGGLE_HIDE_UI':
      return { ...state, hideUi: !state.hideUi };
    default:
      return state;
  }
}
